import { IconName } from '@optimus-web/core';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

export const EnterpriseRateManagementMenu = ({ ...other }) => {
    const isChannelManagerMappingEnabled = useFeatureFlag(FeatureFlag.excelProcessingChannelManagerRateEnabled);

    return (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.RateManagement} />}
            primaryText={<LocalizedText textKey={TextKey.RateManagement} />}
            value="enterpriseRateManagement"
            {...other}
        >
            {createListItemWithLink({
                textKey: TextKey.RatePlural,
                iconName: IconName.RateManagement,
                path: 'EnterpriseRateManagement/Rate/Index',
                tooltip: null,
                isMainItem: true,
            })}
            {createListItemWithLink({
                textKey: TextKey.RateGroupPlural,
                iconName: IconName.RateManagement,
                path: 'EnterpriseRateManagement/RateGroups/Index',
                tooltip: null,
                isMainItem: true,
            })}
            {createListItemWithLink({
                textKey: TextKey.VoucherPlural,
                iconName: IconName.PaymentReport,
                path: 'EnterpriseRateManagement/Voucher/Index',
                tooltip: null,
                isMainItem: true,
            })}
            {isChannelManagerMappingEnabled &&
                createListItemWithLink({
                    textKey: TextKey.ChannelManagerMapping,
                    iconName: IconName.Refresh,
                    path: 'EnterpriseRateManagement/ChannelManagerMapping/Index',
                    tooltip: null,
                    isMainItem: true,
                })}
        </SidebarExpandableListItem>
    );
};
